export default "__VITE_ASSET__Kqv_TI0d__"